import React from 'react'
import { Link } from 'react-router-dom'

const FeedbackCreatedConfirmation: React.FC<{ responseRequired: string }> = ({
  responseRequired,
}) => {
  const govCMSHome = process.env.REACT_APP_GOVCMS_HOME

  return (
    <>
      <h1>Thank you for your feedback</h1>
      {responseRequired.toLowerCase() == 'yes' ? (
        <>
          <p>
            The Office of the Fair Work Ombudsman welcomes feedback about your
            interaction with the agency. It helps us to know what we&apos;re
            doing well and what changes we need to make.
          </p>
          <h1>What happens now</h1>
          <p>
            We&apos;ve received your feedback and it has been forwarded to the
            relevant area. If you&apos;ve chosen to get a response, you&apos;ll
            hear from us soon.
          </p>
        </>
      ) : (
        <>
          <p>
            Thank you for your feedback. It will be considered but we will not
            contact you about it.
          </p>
        </>
      )}

      <p>
        <strong>
          Looking for information about pay or other entitlements or need help
          with a workplace issue?
        </strong>
      </p>
      <p>
        If the query you&apos;ve sent us relates to a workplace issue or
        you&apos;ve asked for help working out entitlements, you&apos;ll need to
        submit an&nbsp;
        <Link to="/my-account/enquiries">online enquiry</Link> through My
        account or&nbsp;
        <a href={govCMSHome + '/about-us/contact-us'}>
          contact the Fair Work Infoline
        </a>
        &nbsp;between 8.00am and 5.30pm.
      </p>
    </>
  )
}

export default FeedbackCreatedConfirmation
